"use strict";
/**
 * Created by orehman on 2/22/2017.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var rxjs_1 = require("rxjs");
var ɵngcc0 = require('@angular/core');
var NgDragDropService = /** @class */ (function () {
    function NgDragDropService() {
        this.onDragStart = new rxjs_1.Subject();
        this.onDragEnd = new rxjs_1.Subject();
    }
    /** @nocollapse */
    NgDragDropService.ctorParameters = function () { return []; };
NgDragDropService.ɵfac = function NgDragDropService_Factory(t) { return new (t || NgDragDropService)(); };
NgDragDropService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: NgDragDropService, factory: function (t) { return NgDragDropService.ɵfac(t); } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgDragDropService, [{
        type: core_1.Injectable
    }], function () { return []; }, null); })();
    return NgDragDropService;
}());
exports.NgDragDropService = NgDragDropService;

